module.exports = __webpack_public_path__ + "static/mp-46c56a0e71e4adf2ed943b9bf4de7063.mp4";